import { render, staticRenderFns } from "./index-landing.vue?vue&type=template&id=5b1ab510&scoped=true&"
import script from "./index-landing.vue?vue&type=script&lang=js&"
export * from "./index-landing.vue?vue&type=script&lang=js&"
import style0 from "./index-landing.vue?vue&type=style&index=0&id=5b1ab510&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ab510",
  null
  
)

export default component.exports